export class ApptDetailModel {
    client_no: number
    last_name: string
    first_name: string
    doctor: string
    dropoff_time: string
    dropoff: boolean
    pet_no: number
    appt_proc_name: string
    appointment_note: string
    code1: string
    code2: string
    code3: string
    appt_fulfill: string

    constructor(
        client_no: number,
        last_name: string,
        first_name: string,
        doctor: string,
        dropoff_time: string,
        dropoff: boolean,
        pet_no: number,
        appt_proc_name: string,
        appointment_note: string,
        code1: string,
        code2: string,
        code3: string,
        appt_fulfill: string
    ) {
        this.client_no = client_no
        this.last_name = last_name
        this.first_name = first_name
        this.doctor = doctor
        this.dropoff_time = dropoff_time
        this.dropoff = dropoff
        this.pet_no = pet_no
        this.appt_proc_name = appt_proc_name
        this.appointment_note = appointment_note
        this.code1 = code1
        this.code2 = code2
        this.code3 = code3
        this.appt_fulfill = appt_fulfill 
    }
}

